import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class BringozColumnChartComponent implements IController {
  data: any;
  from: any;
  to: any;
  isStacked: any;
  showLegend: any;
  colors: any;

  public columnChart: any;
  defaultColors: any;
  format: any;

  constructor(private chartColors, private splitService) {
  }

  $onInit() {
    this.defaultColors = this.chartColors.defaultColors;
    this.format = this.splitService.getDateAndTimeConfig().long;

    this.columnChart = {
      type: 'ColumnChart',
      data: this.data,
      options: {
        isStacked: this.isStacked,
        chartArea: {
          width: '94%'
        },
        hAxis: {
          format: 'dd/MM',
          ticks: this.getTicks(this.data),
          gridlines: {
            color: 'transparent',
          }
        },
        vAxis: {

          viewWindow: {},
          gridlines: {
            color: '#EEEEEE'
          }
        },
        targetAxisIndex: this.showLegend ? 1 : undefined,
        legend: this.showLegend ?
          {
            fontSize: 12,
            color: '#757575'
          }
          : 'none',
        colors: this.colors || this.defaultColors,
        animation: {
          startup: true,
          duration: 1000,
          easing: "inAndOut"
        }
      },
    };
  }

  $onChanges(changes) {
    if (changes.data && !changes.data.isFirstChange()) {
      this.columnChart.data = this.getDataReadyForHebrew(this.data);
      if (this.from && this.to) {
        this.columnChart.options.vAxis.ticks = this.getTicks(this.data);
      }
    }
  }


  private getDataReadyForHebrew(data) {
    _.times(data.getNumberOfRows(), (index) => {
      var string = data.getValue(index, 0);
      if (_.isString(string)) {
        var position = string.search(/[\u0590-\u05FF]/);
        if (position >= 0) {
          data.setValue(index, 0, string.split('').reverse().join(''))
        }
      }
    });
    return data;
  }

  private getTicks(data) {
    let ticks = [];
    for (let i = 0; i < data.getNumberOfRows(); i++) {
      ticks.push(data.getValue(i, 0));
    }
    return ticks;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozColumnChart', {
    bindings: {
      data: '<',
      from: '<',
      to: '<',
      isStacked: '<',
      showLegend: '<?',
      colors: '<?'
    },
    templateUrl: 'app/modules/commons/components/bringoz-column-chart/bringoz-column-chart.html',
    controller: BringozColumnChartComponent
  });
